import { Injectable } from '@angular/core';
import { PortalType } from '@ats/api/cm';
import { SettingsService } from '@cm/core/settings';
import { Observable } from 'rxjs';
import {
	routeWithContext,
	routeWithContext$,
	routeWithNewCulture,
	routeWithNewCulture$,
} from '../functions/routing';

@Injectable({ providedIn: 'root' })
export class CmRoutingService {
	private readonly portal: PortalType;
	constructor(private readonly settings: SettingsService) {
		this.portal = this.settings.portal;
	}

	routeWithContext(path: string[]): string[] {
		return routeWithContext({
			client: this.settings.clientSnapshot ?? undefined,
			culture: this.settings.cultureSnapshot ?? undefined,
			portal: this.portal,
		})(path);
	}

	routeWithContext$(path: string[]): Observable<string[]> {
		return routeWithContext$(
			this.settings.client$,
			this.settings.cultureCode$,
			this.portal
		)(path);
	}

	routeWithNewCulture(path: string[], cultureCode: string): string[] {
		return routeWithNewCulture({
			client: this.settings.clientSnapshot ?? undefined,
			portal: this.portal,
		})(path, cultureCode);
	}

	routeWithNewCulture$(path: string[], cultureCode: string): Observable<string[]> {
		return routeWithNewCulture$(this.settings.client$, this.portal)(path, cultureCode);
	}
}
